export default (givenAddress = {}) => {
  const addr = {
    address2: givenAddress.address2 || '',
    streetNumber: givenAddress.streetNumber || '',
    address: givenAddress.address || '',
    suburb: givenAddress.suburb || '',
    postCode: givenAddress.postCode || '',
    state: givenAddress.state || '',
    countryCode: givenAddress.countryCode || '',
    addressCountry: givenAddress.addressCountry || ''
  };

  const strNumb = addr.streetNumber
    ? ` ${addr.streetNumber}`
    : addr.streetNumber;
  const address = addr.address ? ` ${addr.address}` : addr.address;
  const suburb = addr.suburb ? `, ${addr.suburb}` : addr.suburb;
  const state = addr.state ? `, ${addr.state}` : addr.state;
  const postCode = addr.postCode ? `, ${addr.postCode}` : addr.postCode;
  const country = addr.addressCountry
    ? `, ${addr.addressCountry}`
    : addr.addressCountry;

  return `${addr.address2}${strNumb}${address}${suburb}${state}${postCode}${country}`;
};



// WEBPACK FOOTER //
// ./src/features/fuel-cards/address-filter.js